<template>
  <div class="footerboxs"> 
    <div class="footer">
    <div class="middleCenter">
      <div class="containerbox">
        <div class="leftbox">
          <p class="brankname textl">劳乐斯</p>
          <!-- <p class="textl">让使用成人用品成为一件理所应当的事。</p> -->
          <!-- <p class="textl">Make using adult products a matter of course.</p> -->
        </div>
        <div class="rightbox">
          <p class="brankname">13760291203</p>
          <p>{{ $t("message.time") }}</p>
          <div class="codebox">
            <img src="../assets/code.jpg" alt="">
          </div>
          <p>{{ $t("message.code") }}</p>
        </div>
      </div>
      <div class="col_box">Copyright © 2025 {{ $t("message.company") }}
        <a href="https://beian.miit.gov.cn" target="_blank" class="record">{{ $t("message.record") }}</a>
       </div>
    </div>
  </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
</script>
<style scoped lang='scss'>
.footer {
  width: 100%;
  height: 400px;
  background-color: #000;
  color: rgba(103, 104, 102, 1);
  position: relative;
}
.middleCenter {
  width: 70%;
  margin: 0 auto;
}
.containerbox {
  display: flex;
  justify-content: space-between;
}
.col_box{
    text-align: left;
    position: absolute;
    bottom: 10px;
    font-size: 21px;
}
.leftbox,.rightbox {
    margin-top: 100px;
}
.brankname {
  color: #fff;
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 20px;
}
.textl{
  text-align: left;
}
.codebox{
  width: 100px;
  height: 100px;
  margin: 30px 0 20px;
  img{
    width: 100%;
    height: 100%;
  }
}
.rightbox{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.record{
  color: rgba(103, 104, 102, 1);

}
// .footerboxs{
//   position: fixed;
//   bottom: 0;
//   width: 100%;
// }
</style>